import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const TermsConditions = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="legal-page">
      <div className="legal-header">
        <div className="container">
          <Link to="/" onClick={scrollToTop} className="back-link">
            <ArrowLeft size={20} />
            Back to Home
          </Link>
          <h1 className="legal-title">Terms & Conditions</h1>
          <p className="legal-updated">Last Updated: January 2025</p>
        </div>
      </div>

      <div className="container">
        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Agreement to Terms</h2>
            <p>
              By accessing or using the services of trademarkIcontext, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you may not use our services.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Description of Services</h2>
            <p>
              trademarkIcontext provides trademark registration services, including but not limited to:
            </p>
            <ul>
              <li>Trademark search and clearance</li>
              <li>Trademark application preparation and filing</li>
              <li>USPTO office action responses</li>
              <li>Trademark monitoring and maintenance</li>
              <li>Brand protection consultation</li>
            </ul>
            <p>
              We are not a law firm and do not provide legal advice. Our services are provided in collaboration with licensed attorneys where legal expertise is required.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. Service Fees and Payment</h2>
            <p>
              Our service fees are separate from and in addition to USPTO government filing fees. All fees are clearly outlined in our pricing packages. Payment is required before filing your trademark application. Refund policies vary by package and are subject to specific terms provided at the time of purchase.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Client Responsibilities</h2>
            <p>You agree to:</p>
            <ul>
              <li>Provide accurate and complete information</li>
              <li>Respond promptly to requests for additional information</li>
              <li>Review all documents and applications before submission</li>
              <li>Use your trademark in commerce as represented in your application</li>
              <li>Notify us of any changes to your contact information</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. No Guarantee of Approval</h2>
            <p>
              While we strive for the highest success rate, we cannot guarantee that the USPTO will approve your trademark application. Trademark registration is subject to USPTO examination and approval. Factors outside our control, including prior registrations and USPTO policy changes, may affect the outcome of your application.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Intellectual Property Rights</h2>
            <p>
              All content on our website, including text, graphics, logos, and software, is the property of trademarkIcontext and is protected by copyright and trademark laws. You may not reproduce, distribute, or create derivative works without our express written permission.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Confidentiality</h2>
            <p>
              We maintain strict confidentiality regarding all client information and trademark details. However, please note that trademark applications become public record once filed with the USPTO.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, trademarkIcontext shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services. Our total liability shall not exceed the amount you paid for our services.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless trademarkIcontext, its officers, employees, and agents from any claims, damages, or expenses arising from your use of our services or violation of these terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Termination</h2>
            <p>
              We reserve the right to terminate or suspend your access to our services at any time, with or without cause or notice. You may terminate your use of our services at any time, subject to any ongoing obligations related to pending trademark applications.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Governing Law</h2>
            <p>
              These Terms and Conditions are governed by the laws of the State of California, United States, without regard to its conflict of law provisions. Any disputes shall be resolved in the courts of Los Angeles County, California.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon posting to our website. Your continued use of our services after changes constitutes acceptance of the modified terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>13. Severability</h2>
            <p>
              If any provision of these Terms and Conditions is found to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary, and the remaining provisions shall remain in full force and effect.
            </p>
          </section>

          <section className="legal-section">
            <h2>14. Contact Information</h2>
            <p>For questions about these Terms and Conditions, please contact us:</p>
            <ul>
              <li><strong>Email:</strong> info@trademarkincontext.com</li>
              <li><strong>Phone:</strong> +1 (123) 123-4567</li>
              <li><strong>Address:</strong> 12100 Wilshire Blvd 8th floor, Los Angeles, CA 90025</li>
            </ul>
          </section>

          <section className="legal-section">
            <p className="acknowledgment">
              By using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
